import React from "react";
import "./styles.scss";
import SlideShow from "./components/SlideShow";
import Slide from "./components/Slide";
import results from "./results-26.json";
import { Election } from "./types";

function App() {
  const parsedResults = results as unknown as Election[];

  return (
    <SlideShow results={parsedResults}>
      <Slide type="welcome" />
      <Slide type="standing" standingName="STV Election" />
      <Slide type="welcome" />
      <Slide type="standing" standingName="NUS UK Referendum" />
      <Slide type="welcome" />
      <Slide type="image" imgSrc="/assets/cocktails.jpg" />
      <Slide type="welcome" />
      <Slide type="standing" standingName="Academic Officer" />
      <Slide type="welcome" />
      <Slide type="image" imgSrc="/assets/ragnarok.jpg" />
      <Slide type="image" imgSrc="/assets/football.jpg" />
      <Slide type="welcome" />
      <Slide type="standing" standingName="Activities Officer" />
      <Slide type="welcome" />
      <Slide type="image" imgSrc="/assets/gin.jpg" />
      <Slide type="image" imgSrc="/assets/yuzu.jpg" />
      <Slide type="welcome" />
      <Slide type="standing" standingName="Community and Inclusion Officer" />
      <Slide type="welcome" />
      <Slide type="image" imgSrc="/assets/paradiso.jpg" />
      <Slide type="image" imgSrc="/assets/fight-night.jpg" />
      <Slide type="welcome" />
      <Slide type="standing" standingName="Sports Officer" />
      <Slide type="welcome" />
      <Slide type="image" imgSrc="/assets/rugby.jpg" />
      <Slide type="image" imgSrc="/assets/ragnarok-2.jpg" />
      <Slide type="welcome" />
      <Slide type="standing" standingName="Union Affairs Officer" />
      <Slide type="welcome" />
      <Slide type="image" imgSrc="/assets/roses-2.jpg" />
      <Slide type="image" imgSrc="/assets/trans-lives.jpg" />
      <Slide type="welcome" />
    </SlideShow>
  );
}

export default App;
